import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Button,
  IconButton,
  Drawer,
  Stack,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useTheme as useMuiTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { ThemeContext } from "../../App";
import { CONTACT, openWhatsApp } from "../../utils/constants";

const Header = () => {
  const location = useLocation();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));
  const { mode, toggleTheme } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);

  const navItems = [
    { label: "Home", href: "/", external: false },
    { label: "Projects", href: "/projects", external: false },
    { label: "Resume", href: "/resume", external: false },
    { label: "Contact", href: "/contact", external: false },
    { label: "WhatsApp", href: "whatsapp", external: true },
  ];

  const renderNavButton = (item) => {
    const isActive = !item.external && location.pathname === item.href;

    if (item.external && item.href === "whatsapp") {
      return (
        <Button
          key={item.label}
          onClick={openWhatsApp}
          sx={{
            color: "inherit",
            fontWeight: 600,
          }}
        >
          {item.label}
        </Button>
      );
    }

    if (item.external) {
      return (
        <Button
          key={item.label}
          component="a"
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: "inherit",
            fontWeight: 600,
          }}
        >
          {item.label}
        </Button>
      );
    }

    return (
      <Button
        key={item.label}
        component={Link}
        to={item.href}
        sx={{
          color: isActive ? "primary.main" : "inherit",
          fontWeight: isActive ? 700 : 600,
        }}
      >
        {item.label}
      </Button>
    );
  };

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: "rgba(255,255,255,0.75)",
          color: "text.primary",
          backdropFilter: "blur(14px)",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: "space-between", px: "0 !important" }}>
            <Box
              component={Link}
              to="/"
              sx={{
                textDecoration: "none",
                color: "inherit",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Box
                sx={{
                  width: 42,
                  height: 42,
                  borderRadius: 2,
                  display: "grid",
                  placeItems: "center",
                  color: "white",
                  fontWeight: 800,
                  background: "linear-gradient(135deg, #2563eb, #7c3aed)",
                }}
              >
                DC
              </Box>
              <Box>
                <Box sx={{ fontWeight: 800, lineHeight: 1 }}>
                  {CONTACT.brandName}
                </Box>
                <Box
                  sx={{
                    fontSize: 12,
                    color: "text.secondary",
                    lineHeight: 1.2,
                  }}
                >
                  {CONTACT.role}
                </Box>
              </Box>
            </Box>

            {!isMobile ? (
              <Stack direction="row" spacing={1} alignItems="center">
                {navItems.map(renderNavButton)}
                <IconButton onClick={toggleTheme} color="inherit">
                  <FontAwesomeIcon icon={mode === "light" ? faMoon : faSun} />
                </IconButton>
              </Stack>
            ) : (
              <Stack direction="row" spacing={1} alignItems="center">
                <IconButton onClick={toggleTheme} color="inherit">
                  <FontAwesomeIcon icon={mode === "light" ? faMoon : faSun} />
                </IconButton>
                <IconButton onClick={() => setOpen(true)} color="inherit">
                  <MenuIcon />
                </IconButton>
              </Stack>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 260, p: 3 }}>
          <Stack spacing={2}>
            {navItems.map((item) =>
              item.external && item.href === "whatsapp" ? (
                <Button
                  key={item.label}
                  onClick={() => {
                    openWhatsApp();
                    setOpen(false);
                  }}
                  sx={{ justifyContent: "flex-start" }}
                >
                  {item.label}
                </Button>
              ) : item.external ? (
                <Button
                  key={item.label}
                  component="a"
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpen(false)}
                  sx={{ justifyContent: "flex-start" }}
                >
                  {item.label}
                </Button>
              ) : (
                <Button
                  key={item.label}
                  component={Link}
                  to={item.href}
                  onClick={() => setOpen(false)}
                  sx={{ justifyContent: "flex-start" }}
                >
                  {item.label}
                </Button>
              )
            )}
          </Stack>
        </Box>
      </Drawer>
    </>
  );
};

export default Header;
